import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme';

export const CUSTOM_FORM_ITEM_CLASS_NAME = 'CustomFormItem';
export const CUSTOM_FORM_ITEM_CLASS_SLOTS = ['root'] as const;

export type CustomFormItemClassSlot =
	typeof CUSTOM_FORM_ITEM_CLASS_SLOTS[number];

export interface CustomFormItemClasses {
	root: string;
}

export type CustomFormItemClassKey = keyof CustomFormItemClasses;

export const getCustomFormItemUtilityClass = (slot: string) =>
	generateUtilityClass(CUSTOM_FORM_ITEM_CLASS_NAME, slot);

export const customFormItemClasses: CustomFormItemClasses =
	generateUtilityClasses(CUSTOM_FORM_ITEM_CLASS_NAME, ['root']);

export default customFormItemClasses;
